var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagesChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.5,
    height: 31.5,
    viewBox: "0 0 40.5 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-images",
    "data-name": "Icon awesome-images",
    d: "M33.75,29.25v1.125a3.375,3.375,0,0,1-3.375,3.375h-27A3.375,3.375,0,0,1,0,30.375v-18A3.375,3.375,0,0,1,3.375,9H4.5V23.625a5.631,5.631,0,0,0,5.625,5.625Zm6.75-5.625v-18A3.375,3.375,0,0,0,37.125,2.25h-27A3.375,3.375,0,0,0,6.75,5.625v18A3.375,3.375,0,0,0,10.125,27h27A3.375,3.375,0,0,0,40.5,23.625ZM18,9a3.375,3.375,0,1,1-3.375-3.375A3.375,3.375,0,0,1,18,9ZM11.25,19.125l3.9-3.9a.844.844,0,0,1,1.193,0L19.125,18l9.528-9.528a.844.844,0,0,1,1.193,0L36,14.625V22.5H11.25Z",
    transform: "translate(0 -2.25)",
    fill: "#1a78f3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesChat);
export default __webpack_public_path__ + "static/media/images_chat.9845959cfe44976144a2b20847f370d6.svg";
export { ForwardRef as ReactComponent };